 <!-- <div style="    height: 5.5%;
    width: 100%;
    background: #f8f8f8;
    position: absolute;
    z-index: 100;
    margin-top: 3.57%;">
 <div class="toolbar-scroll" >
 <button mat-icon-button [matMenuTriggerFor]="appsMenu" style="width: fit-content;
    height: fit-content;
    border-radius: unset;
    margin-right: 10px;margin-left: 10px;">
  <mat-icon style="font-size: 25px;">apps</mat-icon>
  <span style="    margin-left: 2px;
    font-size: 1rem;
    color: #1d1d1d;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: normal;">{{selectedTopNavItem.label}}</span>
</button>
<div role="separator" class="tabcollection-separator" style="border-right: 2px solid #ccc;
    height: 20px;
    margin-right: 10px;"></div>
<mat-menu #appsMenu="matMenu" class="apps-menu-panel">
  <ul class="apps-list">
    <li *ngFor="let item of topNavItems" (click)="selectTopNavItem(item)">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </li>
  </ul>
</mat-menu>
          <ng-container *ngFor="let subItem of (selectedTopNavItem?.subToolbarItems || [])">
             <button
                mat-button
                class="nav-item"
                [ngClass]="{ active: currentSection === subItem.section }"
                (click)="handleNavClick(subItem)"
              >
                <mat-icon>{{ subItem.icon }}</mat-icon>
                <span>{{ subItem.label }}</span>
              </button>
          </ng-container>
        </div>
        </div> -->
<div style=" margin-top: 6.5%;display: flex;width: 100%;">
    <app-jsip-left-pannel (sidenavToggle)="isSidenavOpen = $event" class="jsip_Lpannel" [class.collapsed]="!isSidenavOpen"></app-jsip-left-pannel>
<div class="topDiv_with_LPannel" [class.collapsed]="!isSidenavOpen">
  <app-jsip-product-info-bar  (productNavToggle)="selectedProductDetails = $event"></app-jsip-product-info-bar>

<div class="top-outer-div-productdetails" [class.productDetailsCollapsed]="selectedProductDetails == null" style="margin-top: 0;padding:0 10px">
  <div class="label-bar">
     <label i18n="@@spmsUserReg" class="textColour" style="font-size: 18px;
    font-weight: 500;">My Tasks</label>
     <span class="example-spacer"></span>
       <app-common-button
            title="Download"
          icon="fas fa-download"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onDownload()"
          style="margin-right:1%"
          >
      </app-common-button>
       <app-common-button
            
          title="Refresh"
          icon="fas fa-sync-alt"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onRefresh()"
          style="margin-right:1%"
          >
      </app-common-button>
  </div>
  <div style="margin-top: 1.5%;gap: 1%;">
    <!-- Stats -->
<!-- STATS -->
    <div class="stats">

      <div class="counts-bar" (click)="onCardClick('completed')"
       [class.active]="activeFilter === 'completed'">
        <p class="count-label">Completed</p>
        <h2 class="count-text">{{ Completed}}</h2>
      </div>

      <div class="counts-bar" (click)="onCardClick('overdue')"
       [class.active]="activeFilter === 'overdue'">
        <p class="count-label">Overdue</p>
        <h2 class="count-text">{{ overdueCount }}</h2>
      </div>

      <!-- <div class="counts-bar"  (click)="onCardClick('today')"
       [class.active]="activeFilter === 'today'">
        <p class="count-label">Today</p>
        <h2 class="count-text">{{ todayCount }}</h2>
      </div> -->

      <div class="counts-bar"  (click)="onCardClick('upcoming')"
       [class.active]="activeFilter === 'upcoming'">
        <p class="count-label">Upcoming</p>
        <h2 class="count-text">{{ upcomingCount }}</h2>
      </div>

            <div class="counts-bar" (click)="onCardClick('all')"
       [class.active]="activeFilter === 'all'">
        <p class="count-label">Total Tasks</p>
        <h2 class="count-text">{{ totalCount }}</h2>
      </div>

    </div>

  <div style="width: 100%;margin-bottom: 5%;">


    <ag-grid-angular
      style="margin-top: 2%;height: 55vh;"
      class="ag-theme-balham"
      [gridOptions]="gridOptions"
          [columnDefs]="columnDefs"
          [rowData]="rowData"
          [defaultColDef]="defaultColDef"
          [pagination]="true"
          [paginationPageSize]="10"
          [enableBrowserTooltips]="true"
          (gridReady)="onGridReady($event)"
          [components]="components"
          [rowClassRules]="rowClassRules"
          [getRowStyle]="getRowStyle">
    </ag-grid-angular>


  </div>

</div>
</div>
</div>
